import projects from "../data/projects/projects.json";
import {useParams} from "react-router-dom";
import React from "react";
import {Container} from "reactstrap";
import Gallery from "../components/Gallery";

export default function ProjectDetail() {
    const {slug} = useParams();
    const project = projects.find(p => p.slug === slug);
    if (!project) {
        return (<div className="section"><h2>Proje bulunamadı</h2></div>)
    }
    ;

    return (
        <Container>

            <div className="section">
                <div style={{marginTop: "6rem"}}>
                    <h1>{project.name} - {project.city}</h1>
                    <h3>Kapasite: {project.capacity}</h3>
                </div>
            </div>
            <Gallery images={project.images}/>

        </Container>
    );
}
